import { Component, OnInit, HostListener, AfterViewInit, AfterContentInit, Input, Output, EventEmitter } from '@angular/core';
import { ApiService } from '../../../core/services/api.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/core/auth/auth.service';
import { zoomMeetingAction, zoomMeetingButtonLabel } from 'src/app/core/utils/zoom-meeting-status';
@Component({
  standalone: false,
  selector: 'app-zoom-card',
  templateUrl: './zoom-card.component.html',
  styleUrls: ['./zoom-card.component.scss']
})

export class ZoomCardComponent implements OnInit, AfterViewInit, AfterContentInit {
  currentUrl: any;
  is_subscribed: any = 0;
  @Input() meeting: any;
  @Output() meetingClick = new EventEmitter<any>();
  constructor(private apiService: ApiService,
    private router: Router, private route: ActivatedRoute, private authService: AuthService,) {
    this.currentUrl = this.router.url;
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
      }
    });
    this.loadCurrentUser();
  }

  loadCurrentUser() {
    if (localStorage.getItem('currentUser')) {
      const userData = this.authService.decryption(localStorage.getItem('currentUser'));
      this.is_subscribed = userData['response'].is_subscribed;
    }
  }
  ngAfterViewInit() { }
  ngOnInit(): void {

  }
  ngAfterContentInit(): void {

  }
  viewZoomDetails(id: number) {
    this.router.navigate(['zoom/' + id]);
  }
  joinMeeting(id: number, event: Event) {
    event.stopPropagation();
    this.meetingClick.emit(id);
  }
  disabledBtn(id: number, event: Event) {
    event.stopPropagation();
  }

  watchRecording(meeting: any, event: Event) {
    event.stopPropagation();
    if (meeting && meeting.recorded_video_id) {
      this.router.navigate(['video/' + meeting.recorded_video_id]);
    } else if (meeting && meeting.recorded_url) {
      window.open(meeting.recorded_url, '_blank');
    }
  }

  handleMeetingAction(meeting: any, event: Event) {
    event.stopPropagation();
    this.loadCurrentUser();
    switch (zoomMeetingAction(meeting, this.is_subscribed)) {
      case 'subscribe':
        this.router.navigate(['subscription']);
        break;
      case 'join':
        this.joinMeeting(meeting.id, event);
        break;
      case 'recording':
        this.watchRecording(meeting, event);
        break;
    }
  }

  getButtonLabel(meeting: any): string {
    return zoomMeetingButtonLabel(meeting, this.is_subscribed);
  }

}
